import { useSelector } from 'hooks';

export const isUserLoggedIn = () => {
    const { isComplete, isAuthenticated } = useSelector((state) => state.auth);

    return Boolean(isAuthenticated && isComplete);
};
